import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { createRoot } from "react-dom/client";
import uuid from "uuid/v4";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import configureStore from "./redux/configureStore";
import { MetricsState, errorHandler } from "./logging";
import AuthPopup from "./common/authPopup/AuthPopup";

/**
 * Globally import the styles from the shared react component package.
 */
import "@amzn/squad-front-end-shared-react-components/dist/main.css";
import "@amzn/awsui-global-styles/polaris.css";
import { queryClient } from "./react-query/queryClient";

// Initialize global error handling.
window.addEventListener("error", ({ error }) => {
  if (error) {
    errorHandler(error);
  }
});

(globalThis as any).__APP__NAME__ = "crew";

// Define initial state for metrics before redux is initialized.
const isProduction =
  process.env.NODE_ENV === "production" &&
  window.location.hostname.includes("a2z.com");
const metricsConfig: MetricsState = {
  config: {
    isProduction,
    siteName: isProduction ? "Crowd" : "CrowdDebug",
    serviceName: window.location.hostname,
    sessionId: uuid(),
  },
};
const initialState = {
  metrics: metricsConfig,
};
const routerHistory = createBrowserHistory();
const store = configureStore(initialState, routerHistory);

const mountNode = document.querySelector("#app");
if (mountNode) {
  const root = createRoot(mountNode);
  root.render(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <Router history={routerHistory}>
          <div className="awsui">
            <App />
            <AuthPopup />
          </div>
        </Router>
      </QueryClientProvider>
    </Provider>
  );
} else {
  console.error("Failed to find the root element with id 'app'");
}
